import { Field, Input, FluentProvider, webLightTheme } from '@fluentui/react-components';
import React from 'react';
import { Controller, UseFormMethods } from 'react-hook-form';
import { IMilestoneCategory } from '../../../../utils/types/IProcessTemplate';

interface IMilestoneCategoriesFormProps {
  category?: IMilestoneCategory;
  form: UseFormMethods<IMilestoneCategory>;
}

const MilestoneCategoriesForm = (props: IMilestoneCategoriesFormProps): JSX.Element => {
  const { category, form } = props;
  const { control, errors } = form;

  return (
    <FluentProvider theme={webLightTheme}>
      <Controller
        control={control}
        name="name"
        defaultValue={category?.name}
        rules={{
          maxLength: {
            value: 200,
            message: 'Input is greater than the maximum character limit of 200.',
          },
          required: 'Please enter a name',
        }}
        render={({ onChange, onBlur, value, name, ref }) => (
          <Field label="Name" required validationMessage={errors?.name?.message}>
            <Input
              id="name"
              value={value}
              name={name}
              ref={ref}
              onBlur={onBlur}
              onChange={(ev, inputData) => onChange(inputData.value)}
            />
          </Field>
        )}
      />
    </FluentProvider>
  );
};

export default MilestoneCategoriesForm;
